import { breakpointsByName } from 'config/breakpoints';

export const isSPMedium = (width) => width >= breakpointsByName.spMedium;

export const isLarge = (width) => width >= breakpointsByName.large;

export const isExtraLarge = (width) => width >= breakpointsByName.xlarge;
